@if (profile) {
<div class="flex items-center gap-6">
  <img [src]="profile.profileImageUrl || 'assets/images/no-image.jpg'" alt="" class="w-[120px] h-[150px] rounded-xl object-cover" />
  <h2 class="font-bold text-[28px]">
    {{ profile.firstName }} {{ profile.lastName }}
  </h2>
</div>

<p class="my-4 text-base text-gray-600 dark:text-white">
  {{ profile.profileBio }}
</p>
}
